import { Injectable } from '@angular/core';
import { HttpService, PaymentgetwayService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class CreditCardPaymentService {

  constructor(private http: HttpService, private PAYMENT_TYPE: PaymentgetwayService) { }

  makePayment(CREDITCARD_INFO: any, TANX_ID: any) {
    const CREDITCARD_DATA = CREDITCARD_INFO;
    const PAYMENT_TYPE = this.PAYMENT_TYPE?.CreditCard;
    const body = new URLSearchParams();
    body.set("id", TANX_ID);
    body.set("cc[store]", PAYMENT_TYPE?.credit_value_card)
    body.set("cc[number]", CREDITCARD_DATA?.credit_card_number)
    body.set("cc[exp_month]", CREDITCARD_DATA?.credit_card_exp_month)
    body.set("cc[exp_year]", CREDITCARD_DATA?.credit_card_exp_year)
    body.set("cc[cvv]", CREDITCARD_DATA?.credit_card_cvv)
    body.set("cc[name]", CREDITCARD_DATA?.credit_card_exp_month)
    body.set("cc[card]", PAYMENT_TYPE?.credit_value_card)
    body.set("cc[payOption]", PAYMENT_TYPE.credit_value_payOption)
    body.set("payment[payment_type]", PAYMENT_TYPE?.credit_payment_type)
    body.set("payment[value][store]", PAYMENT_TYPE?.credit_value_card)
    body.set("payment[value][number]", CREDITCARD_DATA?.credit_card_number)
    body.set("payment[value][exp_month]", CREDITCARD_DATA?.credit_card_exp_month)
    body.set("payment[value][exp_year]", CREDITCARD_DATA?.credit_card_exp_year)
    body.set("payment[value][cvv]", CREDITCARD_DATA?.credit_card_cvv)
    body.set("payment[value][name]", CREDITCARD_DATA?.credit_card_exp_month)
    body.set("payment[value][card]", PAYMENT_TYPE?.credit_value_card)
    body.set("payment[value][payOption]", PAYMENT_TYPE.credit_value_payOption)
    body.set("is_api_payment", 'true')
    return this.http.flightsave('b2c/booking/payment', body);
  }
}
